import React, { useEffect, useState } from "react";
import "./MyProfile.css";
import { useAuth } from "../context/AuthContext";
import { CircularProgress } from "@mui/material";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { genders } from "../../utils/constants";
import { updatePatient } from "../../api/patient";
import useAppContext from "../context/AppContext";

/**
 * NOTES:
 * only one field should be required
 * why phone is not allowed to update?
 */

// const validUpdateKeys = ["name", "email", "dateOfBirth", "gender"];

const MyProfile = () => {
  const { logout } = useAuth();
  const { openSnackbar } = useAppContext();
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  // console.log("MyProfile user", user);

  const [isEnabledEditDetails, setIsEnabledEditDetails] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [formData, setFormData] = useState({});

  async function onClickUpdate() {
    setLoadingUpdate(true);
    const userUpdate = {
      name: user?.name,
      // phone: user?.phone,
      email: user?.email,
      dateOfBirth: user?.dateOfBirth,
      gender: user?.gender,
      ...formData,
    };
    const updatedPatient = await updatePatient(userUpdate);
    console.log("user updated:", updatedPatient);
    if (updatedPatient) {
      setIsEnabledEditDetails(false);
      setUser(updatedPatient);
    } else {
      openSnackbar({
        severity: "error",
        message: "Could not update user",
      });
    }
    setLoadingUpdate(false);
  }

  function onChangeInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    // console.log("onChangeInput", name, value);
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  function onClickBack() {
    navigate("/", { replace: true });
  }

  function onClickLogout() {
    logout();
  }

  // useEffect(() => {
  //   console.log(
  //     "formData?.dateOfBirth",
  // new Date(formData?.dateOfBirth).getUTCDate(),
  // moment(formData?.dateOfBirth).format("YYYY-MM-DD"),
  //     formData?.dateOfBirth
  //   );
  // }, [formData]);

  return (
    <div id="layout">
      <div className="profile_backButton">
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          onClick={onClickBack}
        >
          <rect
            width="13"
            height="13"
            transform="matrix(-1 0 0 1 13 0)"
            fill="url(#pattern0)"
          />
          <defs>
            <pattern
              id="pattern0"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use xlinkHref="#image0_982_4658" transform="scale(0.00390625)" />
            </pattern>
            <image
              id="image0_982_4658"
              width="256"
              height="256"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>{" "}
        My Profile{" "}
        {loading && <CircularProgress sx={{ color: "white" }} size="1.25rem" />}
      </div>
      <div className="profile_edit_cta">
        <button onClick={() => setIsEnabledEditDetails((prev) => !prev)}>
          Edit Details
        </button>
      </div>
      <div className="my_profile_inputs">
        {" "}
        <form>
          <div className="createProfile_input">
            <label htmlFor="Name">Name</label>
            <input
              onChange={onChangeInput}
              type="text"
              name="name"
              value={formData?.name}
              disabled={!isEnabledEditDetails}
              defaultValue={user?.name}
            />
          </div>
          <div className="createProfile_input">
            <label htmlFor="number">Phone Number</label>
            <input
              onChange={onChangeInput}
              type="number"
              value={formData?.phone}
              disabled
              defaultValue={user?.phone}
            />
          </div>
          <div className="createProfile_input">
            <label htmlFor="email">Email</label>
            <input
              onChange={onChangeInput}
              type="email"
              name="email"
              value={formData?.email}
              disabled={!isEnabledEditDetails}
              defaultValue={user?.email}
            />
          </div>
          <div className="createProfile_input">
            <label htmlFor="date">Date Of Birth</label>
            <input
              onChange={onChangeInput}
              type="date"
              name="dateOfBirth"
              value={formData?.dateOfBirth}
              disabled={!isEnabledEditDetails}
              max={moment().format("YYYY-MM-DD")}
              defaultValue={moment(user?.dateOfBirth).format("YYYY-MM-DD")}
            />
          </div>
          <div className="gender_box">
            <label htmlFor="gender" style={{ width: "100%", margin: "20px 0" }}>
              Gender
            </label>
            {isEnabledEditDetails ? (
              genders.map((gender, i) => {
                return (
                  <span
                    key={i}
                    onClick={() =>
                      onChangeInput({
                        target: { name: "gender", value: gender },
                      })
                    }
                  >
                    <input
                      className="checkbox-tools"
                      type="radio"
                      name="gender"
                      id={`gender-checkbox-${i}`}
                      value={gender?.toUpperCase()}
                    />
                    <label className="for-checkbox-tools" htmlFor="tool-1">
                      {gender}
                    </label>
                  </span>
                );
              })
            ) : (
              <span>
                <input
                  className="checkbox-tools"
                  type="radio"
                  name="gender"
                  // id={`gender-checkbox-${i}`}
                  value={user?.gender}
                  checked
                />
                <label className="for-checkbox-tools" htmlFor="tool-1">
                  {user?.gender}
                </label>
              </span>
            )}
          </div>
        </form>
      </div>
      <div className="profile_details_next_cta">
        <button
          onClick={onClickUpdate}
          disabled={!isEnabledEditDetails}
          style={{ background: isEnabledEditDetails ? undefined : "grey" }}
        >
          {loadingUpdate ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress sx={{ color: "white" }} size="1.25rem" />
            </div>
          ) : (
            "Update"
          )}
        </button>
      </div>
      <div className="profile_details_next_cta">
        <button onClick={onClickLogout}>Log Out</button>
      </div>
    </div>
  );
};

export default MyProfile;
